import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Disable console.log in production for better performance
import './utils/disableConsole';

// Enable content protection (chặn chuột phải, copy, etc.)
import './utils/contentProtection';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
